import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import "./Dashboard.css";

function Dashboard() {
  const [selectedDuty, setSelectedDuty] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [personnelData, setPersonnelData] = useState([]);
  const [dutyHistoryData, setDutyHistoryData] = useState([]);
  const [chuttiGairHazirData, setChuttiGairHazirData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [downloadType, setDownloadType] = useState("all");
  const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");
const [showDateFilter, setShowDateFilter] = useState(false);


  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const dutyCategories = {
    "Fixed Duties": [
      "Mahanubhav/ Gawah Suraksha Duty",
      "Gunner Duty",
      "Mahanubhav Escort Duty",
      "VVIP/ Shok Salami Guard",
      "Bandi Medical Suraksha Guard",
      "VIP/ VVIP Suraksha Duty",
      "Adhikari Awaas Picket Duty",
      "Ratri Pehra Duty",
      "Stamp Paper Suraksha Duty",
      "EVM Suraksha Duty",
      "Paper/ Answer Booklet Suraksha Duty",
      "Quarter Guard Suraksha Duty"
    ],
    "Dynamic Duties": [
      "Hawalat Duty",
      "Hawalat QRT",
      "Kishor Peshi",
      "Kishor Medical",
      "Bandi Medical Prakshisharan",
      "Bandi Sthantharan",
      "Sanwasini Praiksha Duty",
      "Sanwasini Janpad/ Gair Janpad/ Gair Rajya Sthantharan",
      "Gair Janpad/ Gair Rajya Kaman",
      "Parivaar Paramarsh Kendra Duty",
      "Madad Mariz Duty",
      "VIP/ VVIP Escort Duty",
      "Shanti Vyavastha Duty",
      "Vibhinn Prakar Mela Duty",
      "Andar Janpad/ Gair Janpad/ Anya Rajya Khajana Suraksha Duty",
      "Andar Janpad/ Gair Janpad/ Gair Rajya Vishesh Vahak Duty",
      "Vibhinn Prakar Pariksha Duty",
      "Vibhinn Prakar Chunav Duty"
    ]
  };

  const getFinancialYearDates = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    
    let fyStartYear, fyEndYear;
    
    if (currentMonth < 2) {
      fyStartYear = currentYear - 1;
      fyEndYear = currentYear;
    } else {
      fyStartYear = currentYear;
      fyEndYear = currentYear + 1;
    }
    
    const fyStart = new Date(fyStartYear, 2, 1);
    const fyEnd = new Date(fyEndYear, 1, 28);
    if (fyEndYear % 4 === 0 && (fyEndYear % 100 !== 0 || fyEndYear % 400 === 0)) {
      fyEnd.setDate(29);
    }
    
    return { fyStart, fyEnd };
  };

  const getHalfYearDates = () => {
    const { fyStart, fyEnd } = getFinancialYearDates();
    
    const firstHalfStart = new Date(fyStart);
    const firstHalfEnd = new Date(fyStart.getFullYear(), 7, 31);
    
    const secondHalfStart = new Date(fyStart.getFullYear(), 8, 1);
    const secondHalfEnd = new Date(fyEnd);
    
    return { firstHalfStart, firstHalfEnd, secondHalfStart, secondHalfEnd };
  };

  const identifyRepeaters = () => {
    const { fyStart, fyEnd } = getFinancialYearDates();
    const { firstHalfStart, firstHalfEnd, secondHalfStart, secondHalfEnd } = getHalfYearDates();
    const repeaters = [];
    
    personnelData.forEach(person => {
      const personDutyHistory = dutyHistoryData.filter(history => {
        if (history.personnel_id !== person.id) return false;
        if (history.duty_type !== "Dynamic Duties") return false;
        
        const startDate = new Date(history.start_date);
        return startDate >= fyStart && startDate <= fyEnd;
      });
      
      const dutyCount = {};
      personDutyHistory.forEach(history => {
        const duty = history.duty_assignment;
        dutyCount[duty] = (dutyCount[duty] || 0) + 1;
      });
      
      const violations = [];
      Object.entries(dutyCount).forEach(([duty, count]) => {
        if (count > 2) {
          violations.push({ duty, count });
        }
      });
      
      if (violations.length > 0) {
        repeaters.push({
          ...person,
          violations: violations,
          totalDuties: personDutyHistory.length
        });
      }
      
      const firstHalfDuties = {};
      const secondHalfDuties = {};
      
      personDutyHistory.forEach(history => {
        const startDate = new Date(history.start_date);
        const duty = history.duty_assignment;
        
        if (startDate >= firstHalfStart && startDate <= firstHalfEnd) {
          firstHalfDuties[duty] = (firstHalfDuties[duty] || 0) + 1;
        } else if (startDate >= secondHalfStart && startDate <= secondHalfEnd) {
          secondHalfDuties[duty] = (secondHalfDuties[duty] || 0) + 1;
        }
      });
      
      Object.entries(secondHalfDuties).forEach(([duty, count]) => {
        const firstHalfCount = firstHalfDuties[duty] || 0;
        if (firstHalfCount > 0 && count > 1) {
          const existingRepeater = repeaters.find(r => r.id === person.id);
          if (!existingRepeater) {
            repeaters.push({
              ...person,
              violations: [{ duty, count: firstHalfCount + count, reason: "Exceeded half-year limit" }],
              totalDuties: personDutyHistory.length
            });
          }
        }
      });
    });
    
    return repeaters;
  };

  // Get reserved personnel
  const getReservedPersonnel = () => {
    return personnelData.filter(p => 
      p.duty_assignment === "Reserved" || 
      p.duty_assignment === null || 
      p.duty_assignment === ""
    );
  };

  // Get currently absent personnel (Chutti Gair Hazir)
// Alternative: Show ALL chutti gair hazir records
const getAbsentPersonnel = () => {
  return chuttiGairHazirData
    .map(record => {
      const personnel = personnelData.find(p => p.id === record.personnel_id);
      return {
        ...record,
        ...personnel,
        chuttiData: record
      };
    })
    .filter(Boolean);
};
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        const personnelResponse = await fetch(`${API_BASE_URL}/api/personnel`);
        if (!personnelResponse.ok) {
          throw new Error(`HTTP error! status: ${personnelResponse.status}`);
        }
        const personnelResult = await personnelResponse.json();
        setPersonnelData(personnelResult);
        
        const historyResponse = await fetch(`${API_BASE_URL}/api/duty-history`);
        if (historyResponse.ok) {
          const historyResult = await historyResponse.json();
          setDutyHistoryData(historyResult);
        }

        const chuttiResponse = await fetch(`${API_BASE_URL}/api/chutti-gair-hazir`);
        if (chuttiResponse.ok) {
          const chuttiResult = await chuttiResponse.json();
          setChuttiGairHazirData(chuttiResult);
        }
        
        setError(null);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Failed to load data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  const handleRefresh = async () => {
    try {
      setLoading(true);
      
      const personnelResponse = await fetch(`${API_BASE_URL}/api/personnel`);
      if (!personnelResponse.ok) {
        throw new Error(`HTTP error! status: ${personnelResponse.status}`);
      }
      const personnelResult = await personnelResponse.json();
      setPersonnelData(personnelResult);
      
      const historyResponse = await fetch(`${API_BASE_URL}/api/duty-history`);
      if (historyResponse.ok) {
        const historyResult = await historyResponse.json();
        setDutyHistoryData(historyResult);
      }

      const chuttiResponse = await fetch(`${API_BASE_URL}/api/chutti-gair-hazir`);
      if (chuttiResponse.ok) {
        const chuttiResult = await chuttiResponse.json();
        setChuttiGairHazirData(chuttiResult);
      }
      
      setError(null);
      alert('Data refreshed successfully!');
    } catch (err) {
      console.error('Error refreshing data:', err);
      setError('Failed to refresh data');
      alert('Failed to refresh data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const getSuspendedPersonnel = () => {
  return personnelData.filter(p => p.status === 'suspended');
};

// 3. Add getFixedDutyPersonnel and getDynamicDutyPersonnel functions
const getFixedDutyPersonnel = () => {
  return personnelData.filter(p => p.duty_type === 'Fixed Duties' && p.status === 'active');
};

const getDynamicDutyPersonnel = () => {
  return personnelData.filter(p => p.duty_type === 'Dynamic Duties' && p.status === 'active');
};

// Update the downloadExcel function to include date filtering (around line 280)
const downloadExcel = () => {
  try {
    let dataToExport = [];
    let sheetName = 'Personnel Data';

    // Get base data based on download type
    if (downloadType === 'all') {
      dataToExport = personnelData;
      sheetName = 'All Personnel';
    } else if (downloadType === 'fixed') {
      dataToExport = getFixedDutyPersonnel();
      sheetName = 'Fixed Duty Personnel';
    } else if (downloadType === 'dynamic') {
      dataToExport = getDynamicDutyPersonnel();
      sheetName = 'Dynamic Duty Personnel';
    } else if (downloadType === 'repeaters') {
      dataToExport = identifyRepeaters();
      sheetName = 'Duty Repeaters';
    } else if (downloadType === 'reserved') {
      dataToExport = getReservedPersonnel();
      sheetName = 'Reserved Personnel';
    } else if (downloadType === 'absent') {
      dataToExport = getAbsentPersonnel();
      sheetName = 'Absent Personnel';
    } else if (downloadType === 'suspended') {
      dataToExport = getSuspendedPersonnel();
      sheetName = 'Suspended Personnel';
    }

    // Apply date filter if dates are provided
    if (startDate || endDate) {
      dataToExport = dataToExport.filter(person => {
        const joiningDate = person.joining_date ? new Date(person.joining_date) : null;
        
        if (!joiningDate) return false;

        const start = startDate ? new Date(startDate) : null;
        const end = endDate ? new Date(endDate) : null;

        if (start && end) {
          return joiningDate >= start && joiningDate <= end;
        } else if (start) {
          return joiningDate >= start;
        } else if (end) {
          return joiningDate <= end;
        }
        return true;
      });

      // Update sheet name to include date range
      const dateRangeText = startDate && endDate 
        ? `_${startDate}_to_${endDate}`
        : startDate 
        ? `_from_${startDate}`
        : `_until_${endDate}`;
      sheetName += dateRangeText;
    }

    if (dataToExport.length === 0) {
      alert('No data found for the selected criteria!');
      return;
    }

    const excelData = dataToExport.map(person => ({
      'PNO Number': person.pno_no || 'N/A',
      'Name': person.name || 'N/A',
      'Rank': person.rank || 'N/A',
      'Police Station': person.police_station || 'N/A',
      'Contact Number': person.contact_number || 'N/A',
      'Joining Date': person.joining_date ? new Date(person.joining_date).toLocaleDateString('en-IN') : 'N/A',
      'Duty Type': person.duty_type || 'N/A',
      'Current Duty': person.duty_assignment || 'Reserved',
      'Status': person.status || 'N/A',
      'Current Quarter': person.current_quarter || 'N/A',
      'Address': person.address || 'N/A',
      'Emergency Contact': person.emergency_contact || 'N/A',
      'Blood Group': person.blood_group || 'N/A',
      ...(downloadType === 'absent' && {
        'Absent From': person.start_date ? new Date(person.start_date).toLocaleDateString('en-IN') : 'N/A',
        'Absent Until': person.end_date ? new Date(person.end_date).toLocaleDateString('en-IN') : 'N/A',
        'Reason': person.reason || 'N/A',
        'Absence Status': person.status || 'N/A'
      })
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(excelData);

    const colWidths = [
      { wch: 15 }, { wch: 25 }, { wch: 20 }, { wch: 20 },
      { wch: 15 }, { wch: 12 }, { wch: 20 }, { wch: 30 },
      { wch: 12 }, { wch: 20 }, { wch: 30 }, { wch: 20 }, { wch: 10 }
    ];
    ws['!cols'] = colWidths;

    XLSX.utils.book_append_sheet(wb, ws, sheetName.substring(0, 31)); // Excel sheet name limit

    const fileName = `${sheetName.replace(/ /g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(wb, fileName);
    
    alert(`Excel file downloaded successfully! Total records: ${dataToExport.length}`);
  } catch (error) {
    console.error('Error downloading Excel file:', error);
    alert('Error downloading Excel file. Please try again.');
  }
};

// Add this function to clear date filters
const handleClearDateFilter = () => {
  setStartDate("");
  setEndDate("");
};

  const totalPersonnel = personnelData.filter(p => p.status === 'active').length;
  const repeaters = identifyRepeaters();
  const reservedPersonnel = getReservedPersonnel();
  const absentPersonnel = getAbsentPersonnel();

  const suspendedPersonnel = getSuspendedPersonnel();



  const filterPersonnel = (duty, dutyType) => {
    return personnelData.filter(p => {
      const matchesDuty = p.duty_assignment === duty && p.duty_type === dutyType;
      const matchesSearch = searchTerm === "" || 
        p.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
        (p.pno_no && p.pno_no.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (p.rank && p.rank.toLowerCase().includes(searchTerm.toLowerCase()));
      
      return matchesDuty && matchesSearch;
    });
  };

  const getPersonnelCount = (duty, dutyType) => {
    const personnel = personnelData.filter(p => 
      p.duty_assignment === duty && 
      p.duty_type === dutyType &&
      p.status === 'active'
    );
    return personnel.length;
  };

  const getPersonnelForDuty = (duty, dutyType) => {
    return personnelData.filter(p => 
      p.duty_assignment === duty && 
      p.duty_type === dutyType
    );
  };

  if (loading && personnelData.length === 0) {
    return (
      <div className="dashboard-container">
        <div className="loading-spinner">
          <p>Loading personnel data...</p>
        </div>
      </div>
    );
  }

  if (error && personnelData.length === 0) {
    return (
      <div className="dashboard-container">
        <div className="error-message">
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      
  
      
      <div className="stats-container">
        <div className="stat-card">
          <h3>Total Police Personnel</h3>
          <h2>{totalPersonnel}</h2>
        </div>
        <div className="stat-card" style={{ background: repeaters.length > 0 ? '#fee2e2' : '#dcfce7' }}>
          <h3>Duty Repeaters (FY)</h3>
          <h2 style={{ color: repeaters.length > 0 ? '#dc2626' : '#16a34a' }}>
            {repeaters.length}
          </h2>
        </div>
        <div className="stat-card" style={{ background: '#e0f2fe' }}>
          <h3>Reserved Personnel</h3>
          <h2 style={{ color: '#0369a1' }}>
            {reservedPersonnel.length}
          </h2>
        </div>
        <div className="stat-card" style={{ background: absentPersonnel.length > 0 ? '#fef3c7' : '#f0fdf4' }}>
          <h3>Chutti Se Gair Hazir</h3>
          <h2 style={{ color: absentPersonnel.length > 0 ? '#d97706' : '#16a34a' }}>
            {absentPersonnel.length}
          </h2>
        </div>
      </div>
      <div className="stat-card" style={{ background: suspendedPersonnel.length > 0 ? '#fee2e2' : '#f0fdf4' }}>
  <h3>Suspended Personnel</h3>
  <h2 style={{ color: suspendedPersonnel.length > 0 ? '#dc2626' : '#16a34a' }}>
    {suspendedPersonnel.length}
  </h2>
</div>

      <div className="filters-container">
  <input 
    type="text" 
    placeholder="Search by name, PNO no., or rank..." 
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    className="search-input"
  />
  
  <div className="action-buttons" style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
    <button 
      className="btn btn-primary" 
      onClick={handleRefresh}
      disabled={loading}
      style={{ 
        padding: '10px 20px', 
        cursor: loading ? 'not-allowed' : 'pointer',
        opacity: loading ? 0.6 : 1,
        background: '#1e3a8a',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '1rem',
        fontWeight: '600'
      }}
    >
      {loading ? '⟳ Refreshing...' : '🔄 Refresh Data'}
    </button>

    <select 
      value={downloadType}
      onChange={(e) => setDownloadType(e.target.value)}
      style={{
        padding: '10px',
        borderRadius: '8px',
        border: '2px solid #1e3a8a',
        fontSize: '1rem',
        cursor: 'pointer'
      }}
    >
      <option value="all">All Personnel</option>
      <option value="fixed">Fixed Duty Personnel</option>
      <option value="dynamic">Dynamic Duty Personnel</option>
      <option value="repeaters">Duty Repeaters</option>
      <option value="reserved">Reserved Personnel</option>
      <option value="absent">Chutti Se Gair Hazir Personnel</option>
      <option value="suspended">Suspended Personnel</option>
    </select>

    <button 
      className="btn btn-secondary"
      onClick={() => setShowDateFilter(!showDateFilter)}
      style={{ 
        padding: '10px 20px',
        background: showDateFilter ? '#059669' : '#6b7280',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '1rem',
        fontWeight: '600',
        cursor: 'pointer'
      }}
    >
      {showDateFilter ? '✓ Date Filter' : '📅 Date Filter'}
    </button>

    <button 
      className="btn btn-success" 
      onClick={downloadExcel}
      disabled={personnelData.length === 0}
      style={{ 
        padding: '10px 20px', 
        cursor: personnelData.length === 0 ? 'not-allowed' : 'pointer',
        opacity: personnelData.length === 0 ? 0.6 : 1,
        background: '#059669',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '1rem',
        fontWeight: '600'
      }}
    >
      📊 Download Excel
    </button>
  </div>

  {/* Date Filter Section */}
  {showDateFilter && (
    <div style={{
      marginTop: '15px',
      padding: '15px',
      background: '#f3f4f6',
      borderRadius: '8px',
      border: '2px solid #1e3a8a'
    }}>
      <div style={{ 
        display: 'flex', 
        gap: '10px', 
        alignItems: 'center',
        flexWrap: 'wrap'
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <label style={{ fontSize: '0.9rem', fontWeight: '600', color: '#1e3a8a' }}>
            From Date:
          </label>
          <input 
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{
              padding: '8px 12px',
              borderRadius: '6px',
              border: '1px solid #d1d5db',
              fontSize: '1rem'
            }}
          />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <label style={{ fontSize: '0.9rem', fontWeight: '600', color: '#1e3a8a' }}>
            To Date:
          </label>
          <input 
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            min={startDate}
            style={{
              padding: '8px 12px',
              borderRadius: '6px',
              border: '1px solid #d1d5db',
              fontSize: '1rem'
            }}
          />
        </div>

        {(startDate || endDate) && (
          <button
            onClick={handleClearDateFilter}
            style={{
              marginTop: '20px',
              padding: '8px 16px',
              background: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '0.9rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            ✖ Clear Dates
          </button>
        )}

        {(startDate || endDate) && (
          <div style={{
            marginTop: '20px',
            padding: '8px 12px',
            background: '#dbeafe',
            borderRadius: '6px',
            fontSize: '0.9rem',
            color: '#1e40af'
          }}>
            📅 Filtering by joining date: 
            {startDate && ` From ${new Date(startDate).toLocaleDateString('en-IN')}`}
            {endDate && ` To ${new Date(endDate).toLocaleDateString('en-IN')}`}
          </div>
        )}
      </div>
    </div>
  )}
</div>

      <div className="types-container">
        {Object.entries(dutyCategories).map(([dutyType, duties]) => {
          const hasMatchingPersonnel = searchTerm ? 
            duties.some(duty => filterPersonnel(duty, dutyType).length > 0) : 
            true;
          
          if (!hasMatchingPersonnel) return null;
          
          return (
            <div key={dutyType} className="type-column">
              <h2>{dutyType}</h2>
              <div className="duty-list">
                {duties.map((duty, index) => {
                  const count = getPersonnelCount(duty, dutyType);
                  const personnel = filterPersonnel(duty, dutyType);
                  
                  if (searchTerm && personnel.length === 0) return null;
                  
                  return (
                    <div
                      key={`${duty}-${index}`}
                      className={`duty-list-item ${dutyType === 'Dynamic Duties' ? 'duty-item' : ''}`}
                      onClick={() => setSelectedDuty({ dutyType, duty })}
                    >
                      <div className="duty-content">
                        <span className="duty-name">{duty}</span>
                      </div>
                      {count > 0 && (
                        <span className="duty-count">{count}</span>
                      )}
                    </div>
                  );
                })}
                {searchTerm && duties.every(duty => filterPersonnel(duty, dutyType).length === 0) && (
                  <div className="no-duties">No matching personnel found</div>
                )}
              </div>
              
              {dutyType === 'Dynamic Duties' && (
                <>
                  <div className="section-divider" style={{ margin: '20px 0', borderTop: '2px solid #dc2626' }}></div>
                  <h2 style={{ color: '#dc2626', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    ⚠️ Repeaters ({repeaters.length})
                  </h2>
                  <div className="duty-list">
                    {repeaters.length > 0 ? (
                      <div
                        className="duty-list-item duty-item"
                        style={{ 
                          background: '#fef2f2', 
                          borderLeft: '4px solid #dc2626',
                          cursor: 'pointer'
                        }}
                        onClick={() => setSelectedDuty({ dutyType: 'Repeaters', duty: 'Duty Repeaters' })}
                      >
                        <div className="duty-content">
                          <span className="duty-name" style={{ color: '#dc2626', fontWeight: '600' }}>
                            View All Repeaters
                          </span>
                          <span style={{ fontSize: '0.85rem', color: '#991b1b' }}>
                            Personnel exceeding duty limits
                          </span>
                        </div>
                        <span className="duty-count" style={{ background: '#dc2626' }}>
                          {repeaters.length}
                        </span>
                      </div>
                    ) : (
                      <div className="no-duties" style={{ color: '#16a34a' }}>
                        ✓ No duty violations in current FY
                      </div>
                    )}
                  </div>

                  <div className="section-divider" style={{ margin: '20px 0', borderTop: '2px solid #0369a1' }}></div>
                  <h2 style={{ color: '#0369a1', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    📋 Reserved ({reservedPersonnel.length})
                  </h2>
                  <div className="duty-list">
                    {reservedPersonnel.length > 0 ? (
                      <div
                        className="duty-list-item duty-item"
                        style={{ 
                          background: '#e0f2fe', 
                          borderLeft: '4px solid #0369a1',
                          cursor: 'pointer'
                        }}
                        onClick={() => setSelectedDuty({ dutyType: 'Reserved', duty: 'Reserved Personnel' })}
                      >
                        <div className="duty-content">
                          <span className="duty-name" style={{ color: '#0369a1', fontWeight: '600' }}>
                            View All Reserved
                          </span>
                          <span style={{ fontSize: '0.85rem', color: '#075985' }}>
                            Personnel without duty assignment
                          </span>
                        </div>
                        <span className="duty-count" style={{ background: '#0369a1' }}>
                          {reservedPersonnel.length}
                        </span>
                      </div>
                    ) : (
                      <div className="no-duties" style={{ color: '#16a34a' }}>
                        ✓ No reserved personnel
                      </div>
                    )}
                  </div>

                  <div className="section-divider" style={{ margin: '20px 0', borderTop: '2px solid #d97706' }}></div>
                  <h2 style={{ color: '#d97706', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    🏠 Chutti Se Gair Hazir ({absentPersonnel.length})
                  </h2>
                  <div className="duty-list">
                    {absentPersonnel.length > 0 ? (
                      <div
                        className="duty-list-item duty-item"
                        style={{ 
                          background: '#fef3c7', 
                          borderLeft: '4px solid #d97706',
                          cursor: 'pointer'
                        }}
                        onClick={() => setSelectedDuty({ dutyType: 'Absent', duty: 'Absent Personnel' })}
                      >
                        <div className="duty-content">
                          <span className="duty-name" style={{ color: '#d97706', fontWeight: '600' }}>
                            View All Absent
                          </span>
                          <span style={{ fontSize: '0.85rem', color: '#92400e' }}>
                            Personnel currently on approved leave/absence
                          </span>
                        </div>
                        <span className="duty-count" style={{ background: '#d97706' }}>
                          {absentPersonnel.length}
                        </span>
                      </div>
                    ) : (
                      <div className="no-duties" style={{ color: '#16a34a' }}>
                        ✓ All personnel present
                      </div>
                    )}
                  </div>

<div className="section-divider" style={{ margin: '20px 0', borderTop: '2px solid #dc2626' }}></div>
<h2 style={{ color: '#dc2626', display: 'flex', alignItems: 'center', gap: '8px' }}>
  🚫 Suspended Personnel ({suspendedPersonnel.length})
</h2>
<div className="duty-list">
  {suspendedPersonnel.length > 0 ? (
    <div
      className="duty-list-item duty-item"
      style={{ 
        background: '#fee2e2', 
        borderLeft: '4px solid #dc2626',
        cursor: 'pointer'
      }}
      onClick={() => setSelectedDuty({ dutyType: 'Suspended', duty: 'Suspended Personnel' })}
    >
      <div className="duty-content">
        <span className="duty-name" style={{ color: '#dc2626', fontWeight: '600' }}>
          View All Suspended
        </span>
        <span style={{ fontSize: '0.85rem', color: '#991b1b' }}>
          Personnel currently under suspension
        </span>
      </div>
      <span className="duty-count" style={{ background: '#dc2626' }}>
        {suspendedPersonnel.length}
      </span>
    </div>
  ) : (
    <div className="no-duties" style={{ color: '#16a34a' }}>
      ✓ No suspended personnel
    </div>
  )}
</div>
                </>
              )}
            </div>
          );
        })}
      </div>

      {selectedDuty && (
        selectedDuty.dutyType === 'Repeaters' ? (
          <RepeatersModal
            repeaters={repeaters}
            onClose={() => setSelectedDuty(null)}
            API_BASE_URL={API_BASE_URL}
            dutyHistoryData={dutyHistoryData}
          />
        ) : selectedDuty.dutyType === 'Reserved' ? (
          <PersonnelList 
            dutyType="Reserved" 
            duty="Reserved Personnel" 
            onClose={() => setSelectedDuty(null)}
            personnelData={reservedPersonnel}
            API_BASE_URL={API_BASE_URL}
          />
        ) : selectedDuty.dutyType === 'Absent' ? (
          <AbsentPersonnelModal
            absentPersonnel={absentPersonnel}
            onClose={() => setSelectedDuty(null)}
            API_BASE_URL={API_BASE_URL}
          />
        ) : 
selectedDuty.dutyType === 'Suspended' ? (
  <SuspendedPersonnelModal
    suspendedPersonnel={suspendedPersonnel}
    onClose={() => setSelectedDuty(null)}
    API_BASE_URL={API_BASE_URL}
  />
):
        (
          <PersonnelList 
            dutyType={selectedDuty.dutyType} 
            duty={selectedDuty.duty} 
            onClose={() => setSelectedDuty(null)}
            personnelData={getPersonnelForDuty(selectedDuty.duty, selectedDuty.dutyType)}
            API_BASE_URL={API_BASE_URL}
          />
        )
      )}
    </div>
  );
}

function RepeatersModal({ repeaters, onClose, API_BASE_URL, dutyHistoryData }) {
  const [selectedPersonnel, setSelectedPersonnel] = useState(null);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content blocklist-container" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>✖</button>
        <h2 style={{ color: '#dc2626' }}>⚠️ Duty Repeaters - Financial Year</h2>
        <p style={{ marginBottom: '20px', color: '#991b1b' }}>
          Personnel who have exceeded duty assignment limits (more than 2 assignments of same duty type in FY)
        </p>

        <div className="quarter-grid">
          {repeaters.map((person) => (
            <div
              key={person.id}
              className="quarter-card personnel-card"
              style={{ borderLeft: '4px solid #dc2626', background: '#fef2f2' }}
              onClick={() => setSelectedPersonnel(person)}
            >
              {person.image_url && (
                <div className="personnel-image-wrapper">
                  <img 
                    src={`${API_BASE_URL}${person.image_url}`}
                    alt={person.name}
                    className="personnel-thumbnail"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              )}
              <h3>{person.name}</h3>
              <span className="badge">{person.rank}</span>
              <p>PNO: {person.pno_no}</p>
              <div style={{ marginTop: '10px' }}>
                {person.violations.map((v, idx) => (
                  <div key={idx} style={{ 
                    fontSize: '0.85rem', 
                    color: '#dc2626',
                    background: '#fee2e2',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    marginBottom: '4px'
                  }}>
                    <strong>{v.duty}</strong>: {v.count} times
                    {v.reason && <div style={{ fontSize: '0.75rem' }}>({v.reason})</div>}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {selectedPersonnel && (
          <PersonnelModal
            personnel={selectedPersonnel}
            onClose={() => setSelectedPersonnel(null)}
            API_BASE_URL={API_BASE_URL}
            isRepeater={true}
          />
        )}
      </div>
    </div>
  );
}

function PersonnelList({ dutyType, duty, onClose, personnelData, API_BASE_URL }) {
  const [selectedPersonnel, setSelectedPersonnel] = useState(null);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content blocklist-container" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>✖</button>
        <h2>{dutyType} - {duty}</h2>

        <div className="quarter-grid">
          {personnelData.length > 0 ? (
            personnelData.map((person) => (
              <div
                key={person.id}
                className="quarter-card personnel-card"
                onClick={() => setSelectedPersonnel(person)}
              >
                {person.image_url && (
                  <div className="personnel-image-wrapper">
                    <img 
                      src={`${API_BASE_URL}${person.image_url}`}
                      alt={person.name}
                      className="personnel-thumbnail"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                )}
                <h3>{person.name}</h3>
                <span className="badge">{person.rank}</span>
                <p>PNO: {person.pno_no}</p>
                <span className={`status-badge ${person.status}`}>{person.status}</span>
              </div>
            ))
          ) : (
            <p className="no-quarters">No personnel assigned to this duty</p>
          )}
        </div>

        {selectedPersonnel && (
          <PersonnelModal
            personnel={selectedPersonnel}
            onClose={() => setSelectedPersonnel(null)}
            API_BASE_URL={API_BASE_URL}
          />
        )}
      </div>
    </div>
  );
}

function AbsentPersonnelModal({ absentPersonnel, onClose, API_BASE_URL }) {
  const [selectedPersonnel, setSelectedPersonnel] = useState(null);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content blocklist-container" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>✖</button>
        <h2 style={{ color: '#d97706' }}>🏠 Chutti Se Gair Hazir Personnel</h2>
        <p style={{ marginBottom: '20px', color: '#92400e' }}>
          Personnel currently on approved leave/absence (Chutti Gair Hazir)
        </p>

        <div className="quarter-grid">
          {absentPersonnel.length > 0 ? (
            absentPersonnel.map((person) => (
              <div
                key={person.id}
                className="quarter-card personnel-card"
                style={{ borderLeft: '4px solid #d97706', background: '#fef3c7' }}
                onClick={() => setSelectedPersonnel(person)}
              >
                {person.image_url && (
                  <div className="personnel-image-wrapper">
                    <img 
                      src={`${API_BASE_URL}${person.image_url}`}
                      alt={person.name}
                      className="personnel-thumbnail"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                )}
                <h3>{person.name}</h3>
                <span className="badge">{person.rank}</span>
                <p>PNO: {person.pno_no}</p>
                <div style={{ marginTop: '10px' }}>
                  <div style={{ 
                    fontSize: '0.85rem', 
                    color: '#92400e',
                    background: '#fef3c7',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    marginBottom: '4px'
                  }}>
                    <strong>Absent:</strong> {new Date(person.start_date).toLocaleDateString('en-IN')} to {new Date(person.end_date).toLocaleDateString('en-IN')}
                  </div>
                  <div style={{ 
                    fontSize: '0.85rem', 
                    color: '#92400e',
                    background: '#fef3c7',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}>
                    <strong>Reason:</strong> {person.reason}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="no-quarters">No personnel currently absent</p>
          )}
        </div>

        {selectedPersonnel && (
          <PersonnelModal
            personnel={selectedPersonnel}
            onClose={() => setSelectedPersonnel(null)}
            API_BASE_URL={API_BASE_URL}
            isAbsent={true}
            chuttiData={selectedPersonnel.chuttiData}
          />
        )}
      </div>
    </div>
  );
}

function SuspendedPersonnelModal({ suspendedPersonnel, onClose, API_BASE_URL }) {
  const [selectedPersonnel, setSelectedPersonnel] = useState(null);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content blocklist-container" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>✖</button>
        <h2 style={{ color: '#dc2626' }}>🚫 Suspended Personnel</h2>
        <p style={{ marginBottom: '20px', color: '#991b1b' }}>
          Personnel currently under suspension
        </p>

        <div className="quarter-grid">
          {suspendedPersonnel.length > 0 ? (
            suspendedPersonnel.map((person) => (
              <div
                key={person.id}
                className="quarter-card personnel-card"
                style={{ borderLeft: '4px solid #dc2626', background: '#fee2e2' }}
                onClick={() => setSelectedPersonnel(person)}
              >
                {person.image_url && (
                  <div className="personnel-image-wrapper">
                    <img 
                      src={`${API_BASE_URL}${person.image_url}`}
                      alt={person.name}
                      className="personnel-thumbnail"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                )}
                <h3>{person.name}</h3>
                <span className="badge">{person.rank}</span>
                <p>PNO: {person.pno_no}</p>
                <span className="status-badge suspended">suspended</span>
              </div>
            ))
          ) : (
            <p className="no-quarters">No personnel currently suspended</p>
          )}
        </div>

        {selectedPersonnel && (
          <PersonnelModal
            personnel={selectedPersonnel}
            onClose={() => setSelectedPersonnel(null)}
            API_BASE_URL={API_BASE_URL}
            isSuspended={true}
          />
        )}
      </div>
    </div>
  );
}

function PersonnelModal({ personnel, onClose, API_BASE_URL, isRepeater, isAbsent, chuttiData }) {
  const [dutyHistoryRecords, setDutyHistoryRecords] = useState([]);
  const [leaveRecords, setLeaveRecords] = useState([]);
  const [chuttiGairHazirRecords, setChuttiGairHazirRecords] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchPersonnelData = async () => {
      try {
        setDataLoading(true);
        
        const dutyHistoryResponse = await fetch(`${API_BASE_URL}/api/duty-history/personnel/${personnel.id}`);
        if (dutyHistoryResponse.ok) {
          const dutyHistoryData = await dutyHistoryResponse.json();
          setDutyHistoryRecords(dutyHistoryData.slice(0, 10));
        }
        
        const leaveResponse = await fetch(`${API_BASE_URL}/api/leave/${personnel.id}`);
        if (leaveResponse.ok) {
          const leaveData = await leaveResponse.json();
          setLeaveRecords(leaveData.slice(0, 5));
        }

        const chuttiResponse = await fetch(`${API_BASE_URL}/api/chutti-gair-hazir/personnel/${personnel.id}`);
        if (chuttiResponse.ok) {
          const chuttiData = await chuttiResponse.json();
          setChuttiGairHazirRecords(chuttiData.slice(0, 10));
        }
        
      } catch (err) {
        console.error('Error fetching personnel data:', err);
        setDutyHistoryRecords([]);
        setLeaveRecords([]);
        setChuttiGairHazirRecords([]);
      } finally {
        setDataLoading(false);
      }
    };

    fetchPersonnelData();
  }, [personnel.id, API_BASE_URL]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const fullImageUrl = personnel.image_url ? `${API_BASE_URL}${personnel.image_url}` : null;

  return (
    <>
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content quarter-modal personnel-details-modal" onClick={(e) => e.stopPropagation()}>
          <button className="close-btn" onClick={onClose}>✖</button>
          
          <h2>Personnel Details - {personnel.name}</h2>
          {isRepeater && (
            <div style={{ 
              background: '#fee2e2', 
              border: '2px solid #dc2626', 
              padding: '10px', 
              borderRadius: '8px',
              marginBottom: '15px',
              color: '#991b1b'
            }}>
              <strong>⚠️ REPEATER ALERT:</strong> This personnel has exceeded duty assignment limits
            </div>
          )}
          {isAbsent && chuttiData && (
            <div style={{ 
              background: '#fef3c7', 
              border: '2px solid #d97706', 
              padding: '10px', 
              borderRadius: '8px',
              marginBottom: '15px',
              color: '#92400e'
            }}>
              <strong>🏠 CHUTTI SE GAIR HAZIR:</strong> {formatDate(chuttiData.start_date)} to {formatDate(chuttiData.end_date)}
              <br />
              <strong>Reason:</strong> {chuttiData.reason}
            </div>
          )}
          
          {fullImageUrl && (
            <div className="personnel-detail-image-container" onClick={() => setSelectedImage(fullImageUrl)}>
              <img 
                src={fullImageUrl}
                alt={personnel.name}
                className="personnel-detail-image"
                onError={(e) => {
                  e.target.parentElement.style.display = 'none';
                }}
              />
              <span className="image-label">Click to enlarge</span>
            </div>
          )}
          
          <div className="details-grid">
            <div className="detail-item">
              <label>PNO Number:</label>
              <span>{personnel.pno_no}</span>
            </div>
            
            <div className="detail-item">
              <label>Rank:</label>
              <span>{personnel.rank}</span>
            </div>
            
            <div className="detail-item">
              <label>Police Station:</label>
              <span>{personnel.police_station || "N/A"}</span>
            </div>
            
            <div className="detail-item">
              <label>Contact Number:</label>
              <span>{personnel.contact_number || "Not Updated"}</span>
            </div>
            
            <div className="detail-item">
              <label>Allotment Date:</label>
              <span>{formatDate(personnel.joining_date)}</span>
            </div>
            
            <div className="detail-item">
              <label>Duty Type:</label>
              <span>{personnel.duty_type || "N/A"}</span>
            </div>
            
            <div className="detail-item">
              <label>Current Duty:</label>
              <span>{personnel.duty_assignment || "Reserved"}</span>
            </div>
            
            <div className="detail-item">
              <label>Status:</label>
              <span className={`status-badge ${personnel.status}`}>{personnel.status}</span>
            </div>
            
             <div className="detail-item" style={{gridColumn: '1/-1'}}>
    <label>Description:</label>
    <div style={{
      background: '#f9fafb',
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid #e5e7eb',
      minHeight: '60px',
      whiteSpace: 'pre-wrap',
      lineHeight: '1.6'
    }}>
      {personnel.description ? (
        <span style={{color: '#374151'}}>{personnel.description}</span>
      ) : (
        <span style={{color: '#9ca3af', fontStyle: 'italic'}}>No description provided</span>
      )}
    </div>
            </div>
          </div>

          <div className="section-divider"></div>

          {dataLoading ? (
            <div className="loading-bills">
              <p>Loading duty history and leave data...</p>
            </div>
          ) : (
            <>
              <h3>📋 Past Duty Records</h3>
              <div className="bills-grid">
                {dutyHistoryRecords.length > 0 ? (
                  dutyHistoryRecords.map((record, index) => (
                    <div key={index} className="bill-card duty-history-card">
                      <p><strong>{record.duty_type}</strong></p>
                      <p className="duty-assignment">{record.duty_assignment}</p>
                      <div className="duty-dates">
                        <small>📅 {formatDate(record.start_date)}</small>
                        <small>→</small>
                        <small>📅 {formatDate(record.end_date)}</small>
                      </div>
                      {record.location && (
                        <small className="location">📍 {record.location}</small>
                      )}
                      {record.remarks && (
                        <p className="remarks">{record.remarks}</p>
                      )}
                    </div>
                  ))
                ) : (
                  <p className="no-data">No past duty records found</p>
                )}
              </div>

              <div className="section-divider"></div>

              <h3>🏠 Chutti Gair Hazir Records</h3>
              <div className="repair-work-section">
                {chuttiGairHazirRecords.length > 0 ? (
                  chuttiGairHazirRecords.map((record, index) => (
                    <div key={index} className="repair-detail" style={{ 
                      borderLeft: record.status === 'approved' ? '4px solid #16a34a' : 
                                record.status === 'rejected' ? '4px solid #dc2626' : '4px solid #d97706'
                    }}>
                      <p className="repair-description">
                        <strong>Absence Period:</strong> {formatDate(record.start_date)} to {formatDate(record.end_date)}
                      </p>
                      <div className="repair-meta">
                        <span><strong>Reason:</strong> {record.reason}</span>
                        <span className={`status-badge ${record.status}`}>{record.status}</span>
                      </div>
                      {record.remarks && (
                        <p className="admin-remarks">
                          <strong>Admin Remarks:</strong> {record.remarks}
                        </p>
                      )}
                      {record.approved_by && (
                        <p className="admin-remarks">
                          <strong>Approved By:</strong> {record.approved_by}
                        </p>
                      )}
                      {record.approval_date && (
                        <p className="admin-remarks">
                          <strong>Approval Date:</strong> {formatDate(record.approval_date)}
                        </p>
                      )}
                    </div>
                  ))
                ) : (
                  <p className="no-data">No chutti gair hazir records found</p>
                )}
              </div>

              <div className="section-divider"></div>

              <h3>🏖️ Leave Records</h3>
              <div className="repair-work-section">
                {leaveRecords.length > 0 ? (
                  leaveRecords.map((leave, index) => (
                    <div key={index} className="repair-detail">
                      <p className="repair-description">
                        <strong>{leave.leave_type}</strong> - {leave.reason}
                      </p>
                      <div className="repair-meta">
                        <span>From: {formatDate(leave.start_date)}</span>
                        <span>To: {formatDate(leave.end_date)}</span>
                        <span className={`status-badge ${leave.status}`}>{leave.status}</span>
                      </div>
                      {leave.remarks && (
                        <p className="admin-remarks">Admin: {leave.remarks}</p>
                      )}
                    </div>
                  ))
                ) : (
                  <p className="no-data">No leave records found</p>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {selectedImage && (
        <div className="image-modal-overlay" onClick={() => setSelectedImage(null)}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedImage(null)}>✖</button>
            <img src={selectedImage} alt="Personnel Full View" className="full-size-image" />
          </div>
        </div>
      )}
    </>
  );
}

export default Dashboard;
